import { Link } from 'react-router-dom';
import { Page } from '../../components/common';
import { useHubLogin } from '../../session';
import { visibleNav } from '../../nav';
import { findNode } from '@nyce/admin-kit/console';
import '../onboarding.css';

/** The Onboarding group page: one card per wizard the operator may run. */
export function OnboardingLauncherPage() {
  const login = useHubLogin();
  const entries = findNode(visibleNav(login?.scopes), 'onboarding')?.children?.filter((n) => !!n.path) ?? [];
  return (
    <Page
      title="Onboarding"
      description="Guided setup of a new customer, installation or module. Each wizard checks what is already in place, does the rest with you, produces the config files the site needs and waits until it works. Re-run one at any time: finished steps just show as done."
    >
      <div className="ob-cards" data-testid="onboarding-cards">
        {entries.map((n) => (
          <Link key={n.path} to={n.path!} className="nyk-card ob-card" data-wizard={n.path}>
            <h3>{n.label}</h3>
            <p>{n.description}</p>
          </Link>
        ))}
        <Link to="/onboarding/guides" className="nyk-card ob-card" data-wizard="/onboarding/guides">
          <h3>Installation guides</h3>
          <p>Step-by-step guides for site IT and customer admins, printable.</p>
        </Link>
      </div>
    </Page>
  );
}
